export type PromptWebhookTrigger = 'commit' | 'tag:create' | 'tag:update';

export const WEBHOOK_TRIGGERS: Record<
  PromptWebhookTrigger,
  { label: string; description: string }
> = {
  commit: {
    label: 'Commit',
    description: 'Trigger webhook when a new prompt commit is created',
  },
  'tag:create': {
    label: 'Tag Create',
    description: 'Trigger webhook when a commit tag is created',
  },
  'tag:update': {
    label: 'Tag Update',
    description: 'Trigger webhook when a commit tag is updated',
  },
} as const;

export type BasePromptWebhook = {
  url: string;
  headers: Record<string, string>;
};

export type PromptWebhookCreate = BasePromptWebhook & {
  triggers: PromptWebhookTrigger[];
  include_prompts: string[];
  exclude_prompts: string[];
};

export type PromptWebhookUpdate = Partial<BasePromptWebhook> & {
  triggers?: PromptWebhookTrigger[];
  include_prompts?: string[];
  exclude_prompts?: string[];
};

export type PromptWebhook = BasePromptWebhook & {
  id: string;
  triggers: PromptWebhookTrigger[];
  created_at: string;
  updated_at: string;
};

export type PromptWebhookPayload = {
  prompt_id: string;
  prompt_name: string;
  manifest: Record<string, unknown>;
  commit_hash: string;
  created_at: string;
  created_by: string;
  event: PromptWebhookTrigger;
};

export type PromptWebhookTest = {
  payload: PromptWebhookPayload;
  webhook: PromptWebhookCreate;
};
